<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span>{{ $t("common.create") }}</span>
      </h2>

      <b-form-tags v-model="form.products" size="lg" class="mb-2" add-on-change no-outer-focus>
        <template v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }">
          <b-form-select v-bind="inputAttrs" v-on="inputHandlers" :disabled="disabled || products.length === 0" :options="products">
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value=""> {{ $t("product.text") }}</option>
            </template>
          </b-form-select>

          <ul v-if="tags.length > 0" class="list-inline d-inline-block mt-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag @remove="removeTag(tag)" :title="tag" :disabled="disabled" variant="primary">{{ tag }}</b-form-tag>
            </li>
          </ul>
        </template>
      </b-form-tags>

      <filter-select
        class="mt-4"
        id="process-filter"
        ref="process-filter"
        :placeholder="$t('process.select')"
        :multiple="!isEditMode"
        :isValid="!$v.form.process.$invalid"
        :displayCount="3"
        @filter="onProcessSearch"
        :selected="form.process"
        @changed="processSelect"
        track="_id"
      />
      <filter-select
        class="mt-4"
        id="process-datasource-filter"
        ref="process-datasource-filter"
        :placeholder="$t('datasource.select')"
        :multiple="!isEditMode"
        :isValid="!$v.form.datasource.$invalid"
        :displayCount="3"
        @filter="onDatasourceSearch"
        :selected="form.datasource"
        @changed="datasourceSelect"
        track="_id"
      />
      <sweet-input
        v-model="form.since"
        :isValid="!$v.form.since.$error"
        @input="$v.form.since.$touch()"
        layout="vertical"
        placeholder="Hangi Zamandan İtibaren Saklanacak"
        label="Hangi Zamandan İtibaren Saklanacak"
        labelClass="mt-3"
      />
      <sweet-input
        v-model="form.period"
        :isValid="!$v.form.period.$error"
        @input="$v.form.period.$touch()"
        type="number"
        layout="vertical"
        placeholder="Saklama Süresi (Ay)"
        label="Saklama Süresi  (Ay)"
        labelClass="mt-3"
      />
      <br />

      <sweet-textarea v-model="form.legalBasis" :isValid="true" layout="vertical" placeholder="Yasal Dayanak" label="Yasal Dayanak" :rows="3" />

      <br />
      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";
const state = "processDatasourceStoragePeriod";

export default {
  components: { SweetTextarea },
  props: ["state"],
  data() {
    return {
      form: { products: [], process: undefined, datasource: undefined, since: undefined, legalBasis: undefined, period: undefined },
    };
  },
  validations: {
    form: {
      process: {},
      datasource: {},
      period: {
        required,
      },

      since: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v && Object.keys(v).length > 0) {
          this.form = { ...v, process: v.process, datasource: v.datasource };
        } else {
          this.form = {};
        }
      },
    },
  },
  computed: {
    isWorkspaceLayout() {
      return this.state === "workspaceProcessDatasourceStoragePeriod";
    },
    isUpdating() {
      return this.$store.getters[`${this.state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${this.state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${this.state}/isEditMode`];
    },
  },
  async mounted() {
    this.state = this.state || state;
  },
  methods: {
    async save() {
      this.$emit("onSave", this.form);
    },

    async onProcessSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceProcess" : "managementProcess";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    processSelect(item) {
      this.form = { ...this.form, process: this.isEditMode ? [item] : item };
    },
    async onDatasourceSearch(value, callback) {
      const store = this.isWorkspaceLayout ? "workspaceDatasource" : "managementDatasource";
      const response = await this.$store.dispatch(`${store}/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...(!this.isWorkspaceLayout && { "scope.value": { value: "system", isObject: true } }) },
      });
      callback(response.data?.docs ?? []);
    },
    datasourceSelect(item) {
      this.form = { ...this.form, datasource: this.isEditMode ? [item] : item };
    },
  },
};
</script>
